import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.keys.js";
import { defineComponent, ref, watch } from "vue";
import axios from "@/api/axios";
import { useRouter } from "vue-router";
import Cookies from "js-cookie";
import useCurrentInstance from "./hooks/useCurrentInstance";
import store from "./store";
import { useStore } from "vuex";
export default defineComponent({
  setup: function setup() {
    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var instance = axios();
    var router = useRouter();
    var whiteList = ["/login", "/", "/index", "/loginChange", "/details", "/multiColumn", "/organization", "/dataScreens", "/greenScreens", "/redScreens"]; // 白名单

    var stores = useStore();
    setTimeout(function () {
      var tokenones = Cookies.get("token");
      var userids = sessionStorage.getItem('user');
      console.log("ceshdi", userids, tokenones);

      if (tokenones && userids) {
        console.log("ceshdi");
        store.dispatch("webSocket/setNewWebsockety", {
          data: JSON.parse(sessionStorage.getItem('user')).userId,
          token: tokenones
        });
        sessionStorage.setItem("out", "0");
      }
    }, 500);
    router.beforeEach( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(to, form, next) {
        var token, _yield$globalProperti, data, account, userId, organizeId, username, userObj, res, isDemonstrate;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // const token = sessionStorage.getItem("token");
                token = Cookies.get("token");

                if (!token) {
                  _context.next = 22;
                  break;
                }

                if (!(Object.keys(instance.defaults.headers).indexOf("Authorization") == -1)) {
                  _context.next = 19;
                  break;
                }

                instance.defaults.headers.Authorization = token; //重新获取人员信息
                //储存用户信息

                _context.next = 6;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getInformation"]();

              case 6:
                _yield$globalProperti = _context.sent;
                data = _yield$globalProperti.data;
                account = data.account, userId = data.userId, organizeId = data.organizeId, username = data.username;
                userObj = {
                  account: account,
                  userId: userId,
                  organizeId: organizeId,
                  username: username
                };
                store.dispatch("user/setuser", userObj);
                _context.next = 13;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getSwitchList"]();

              case 13:
                res = _context.sent;

                if (res.code == 0) {
                  store.dispatch("column/setMeunList", res.data);
                }

                _context.next = 17;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getDemonstration"]({
                  name: 'demo_enabled'
                });

              case 17:
                isDemonstrate = _context.sent;

                if (isDemonstrate.code == 0) {
                  if (isDemonstrate.data.configValue == 'on') {
                    store.dispatch("system/setDemonstration", true);
                  } else {
                    store.dispatch("system/setDemonstration", false);
                  }
                }

              case 19:
                next();
                _context.next = 23;
                break;

              case 22:
                if (whiteList.indexOf(to.path) > -1) {
                  next();
                } else {
                  next("/");
                }

              case 23:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      };
    }());
    watch(function () {
      return stores.state.webSocket.aWebSocket;
    }, function () {
      objweb();
    }, {
      deep: true
    });
    var lists = ref([]);
    var listlength = ref(0);
    setweb();

    function objweb() {
      var aWebSocket = stores.state.webSocket.aWebSocket; // aWebSocket.onopen = function (event) {
      //   console.log("链接打开", event);
      //   // console.log(aWebSocket.protocol,"jfdh");
      // };

      aWebSocket.onmessage = function (event) {
        heartbeat(aWebSocket);
        console.debug("发来消息：", event);

        if (JSON.parse(event.data).event == "message") {
          if (lists.value.length == 0) {
            lists.value = JSON.parse(JSON.parse(event.data).data);
            listlength.value += lists.value.length;
            stores.dispatch("webSocket/setactionbeage", listlength.value);
          } else {
            lists.value = JSON.parse(JSON.parse(event.data).data);
            listlength.value = lists.value.length;
            stores.dispatch("webSocket/setactionbeage", listlength.value);
          }
        }
      };

      aWebSocket.onerror = function (event) {
        console.error("链接错误:", event);
        setTimeout(function () {
          setweb();
        }, 50000);
      };

      aWebSocket.onclose = function () {
        console.log("连接断开");
      };
    }

    function setweb() {
      var userid = "";

      if (sessionStorage.getItem("out") && sessionStorage.getItem("out") != "1") {
        var _JSON$parse;

        var token = Cookies.get("token");
        userid = (_JSON$parse = JSON.parse(sessionStorage.getItem("user"))) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.userId;
        stores.dispatch("webSocket/setNewWebsockety", {
          data: userid,
          token: token
        });
      } // aWebSocket = new WebSocket(
      //  ` ${ process.env.VUE_APP_PCHREFWS}system/websocket/pc/api/pushMessage/${userid}`
      // );

    }

    var timeout;
    var tokens = Cookies.get("token");

    function heartbeat(aWebSocket) {
      //3分钟发一次心跳
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        aWebSocket.send("ping");
      }, 50000);
    }
  }
});